const SEND_FILE_TO_FLOW = 0;

export default {
  SEND_FILE_TO_FLOW
};
